import {
  ADD_MUNICIPALITY_TO_KJS,
  ADD_MUNICIPALITY_TO_KJS_START,
  ADD_MUNICIPALITY_TO_KJS_ERROR,
  UPDATE_MUNICIPALITY_WITH_KJS,
  UPDATE_MUNICIPALITY_WITH_KJS_START,
  UPDATE_MUNICIPALITY_WITH_KJS_ERROR,
  FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE,
  FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE_START,
  FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE_ERROR,
  FIND_ALL_KJS_WITH_MUNICIPALITY_FILTER_PAGEABLE,
  FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS,
  FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS_START,
  FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS_ERROR,
  FIND_ALL_KJS_WITH_MUNICIPALITY_BY_USER,
  FIND_ALL_KJS_WITH_MUNICIPALITY_BY_USER_START,
  FIND_ALL_KJS_WITH_MUNICIPALITY_BY_USER_ERROR,
  CLEAR_KJS_WITH_MUNICIPALITY,
} from '../actions/types';

const initialState = {
  kjsWithMunicipalityList: [],
  kjsWithMunicipality: {},
  loading: false,
  error: undefined,
  totalElements: '',
};

const findAllKjsWithMunicipalityByKjsIdStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllKjsWithMunicipalityByKjsId = (state, action) => {
  return {
    ...state,
    loading: false,
    kjsWithMunicipalityList: action.payload,
  };
};

const findAllKjsWithMunicipalityByKjsIdError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const createKjsWithMunicipality = (state, action) => {
  return {
    ...state,
    loading: false,
    kjsWithMunicipality: action.payload,
    error: undefined,
  };
};

const updateKjsWithMunicipality = (state, action) => {
  return {
    ...state,
    kjsWithMunicipalityList: state.kjsWithMunicipalityList.map(
      (kjsWithMunicipality) =>
        kjsWithMunicipality.id === action.payload.id
          ? action.payload
          : kjsWithMunicipality
    ),
    loading: false,
  };
};

const createKjsWithMunicipalityStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const createKjsWithMunicipalityError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const findAllKjsWithMunicipalityPageableStart = (state) => {
  return {
    ...state,
    loading: true,
    error: undefined,
  };
};

const findAllKjsWithMunicipalityPageable = (state, action) => {
  return {
    ...state,
    loading: false,
    numberOfPages: action.payload[1],
    totalElements: action.payload[2],
    kjsWithMunicipalityList: action.payload[0],
  };
};

const findAllKjsWithMunicipalityPageableError = (state, action) => {
  return {
    ...state,
    error: action.payload,
    loading: false,
  };
};

const clearKjsWithMunicipality = (state) => {
  return {
    ...state,
    kjsWithMunicipalityList: [],
  };
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_MUNICIPALITY_TO_KJS_START:
    case UPDATE_MUNICIPALITY_WITH_KJS_START:
      return createKjsWithMunicipalityStart(state);
    case ADD_MUNICIPALITY_TO_KJS:
      return createKjsWithMunicipality(state, action);
    case UPDATE_MUNICIPALITY_WITH_KJS:
      return updateKjsWithMunicipality(state, action);
    case ADD_MUNICIPALITY_TO_KJS_ERROR:
    case UPDATE_MUNICIPALITY_WITH_KJS_ERROR:
      return createKjsWithMunicipalityError(state, action);
    case FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS_START:
    case FIND_ALL_KJS_WITH_MUNICIPALITY_BY_USER_START:
      return findAllKjsWithMunicipalityByKjsIdStart(state);
    case FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS:
    case FIND_ALL_KJS_WITH_MUNICIPALITY_BY_USER:
      return findAllKjsWithMunicipalityByKjsId(state, action);
    case FIND_ALL_KJS_WITH_MUNICIPALITY_BY_KJS_ERROR:
    case FIND_ALL_KJS_WITH_MUNICIPALITY_BY_USER_ERROR:
      return findAllKjsWithMunicipalityByKjsIdError(state, action);
    case FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE_START:
      return findAllKjsWithMunicipalityPageableStart(state);
    case FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE:
    case FIND_ALL_KJS_WITH_MUNICIPALITY_FILTER_PAGEABLE:
      return findAllKjsWithMunicipalityPageable(state, action);
    case FIND_ALL_KJS_WITH_MUNICIPALITY_PAGEABLE_ERROR:
      return findAllKjsWithMunicipalityPageableError(state, action);
    case CLEAR_KJS_WITH_MUNICIPALITY:
      return clearKjsWithMunicipality(state);

    default:
      return state;
  }
}
